import BreadCrumbs from '@/components/atom/BreadCrumbs';
import TemplateLayout from '@/components/layouts/TemplateLayout';
import StickyAppHeader from '@/components/molecules/sticky-app-header';
import NotFoundTemplate from '@/components/templates/error/not-found/NotFoundTemplate';
import { Client, ClientType } from '@/types/app';
import { ROUTES } from '@/types/common';
import MagazineAuthorInfo from '@/widgets/magazine-author-detail/ui/MagazineAuthorInfo';
import MagazineListByAuthor from '@/widgets/magazine-author-detail/ui/MagazineListByAuthor';
import useMagazineAuthorDetailViewModel from '../hooks/useMagazineAuthorDetailViewModel';

interface Props {
  client: Client;
}

const MagazineAuthorDetailView = ({ client }: Props) => {
  const viewModel = useMagazineAuthorDetailViewModel();
  const shouldShowBreadCrumbs = client.clientType === ClientType.WEB;

  if (!viewModel.magazineAuthor) return <NotFoundTemplate />;

  return (
    <>
      <TemplateLayout.Wrapper>
        <div suppressHydrationWarning>
          {shouldShowBreadCrumbs && (
            <BreadCrumbs.Wrapper>
              <BreadCrumbs
                visible
                name={viewModel.magazineAuthor?.getDisplayDoctorName() ?? ''}
                path={`${ROUTES.AUTHOR.DETAIL.path}/${viewModel.id}`}
                type='magazine-author'
                urlParameter={viewModel.id}
              />
            </BreadCrumbs.Wrapper>
          )}
        </div>
        {client.isWebView && (
          <TemplateLayout.Header useSafeArea>
            <StickyAppHeader title={viewModel.magazineAuthor?.getDisplayDoctorName()} />
          </TemplateLayout.Header>
        )}
        <TemplateLayout.Content>
          <MagazineAuthorInfo
            magazineAuthor={viewModel.magazineAuthor}
            openSocialMediaLink={viewModel.openSocialMediaLink}
            moveToAuthorHospital={viewModel.moveToAuthorHospital}
          />

          <div className={'h-[1px] w-full bg-gray-40'} />

          <MagazineListByAuthor
            magazineByAuthorPublicId={viewModel.magazineByAuthorPublicId}
            currentPage={viewModel.currentPage}
            queries={viewModel.queries}
            paginationBaseUrl={viewModel.paginationBaseUrl}
          />
        </TemplateLayout.Content>
      </TemplateLayout.Wrapper>
    </>
  );
};

export default MagazineAuthorDetailView;
